/* Passendes Zubehör für deinen Grill: Warenkorb-Knopf (AJAX) + Grössen-Auswahl auf der Finder-Seite */
(function () {
  "use strict";
  if (window.__azZubehoer) return;
  window.__azZubehoer = true;

  /* 1. In den Warenkorb legen, ohne Seitenwechsel; danach dasselbe Ereignis wie die Kaufbox (Hinweis oben rechts) */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest && e.target.closest("[data-az-zb-add]");
    if (!btn || btn.disabled) return;
    var box = btn.closest("[data-az-zb]");
    var id = parseInt(btn.getAttribute("data-variant"), 10);
    if (!id) return;
    btn.classList.add("is-busy");
    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : "/cart/add") + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) throw new Error(res.description || res.message || "");
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "azado_zubehoer_add",
          gruppe: box ? box.getAttribute("data-gruppe") : "",
          handle: btn.getAttribute("data-handle"),
          variant_id: id
        });
        document.dispatchEvent(new CustomEvent("cart:added", { detail: res }));
      })
      .catch(function (err) {
        if (window.azadoInstantFail) window.azadoInstantFail((err && err.message) || "");
      })
      .finally(function () { btn.classList.remove("is-busy"); });
  });

  /* 2. Finder-Seite: Modell + Einbauversion wählen, nur das passende Panel zeigen */
  function initFinder(root) {
    var tiles = root.querySelectorAll("[data-az-zbf-grill]");
    var einbauBox = root.querySelector("[data-az-zbf-einbau]");
    var empty = root.querySelector("[data-az-zbf-empty]");
    var panels = root.querySelectorAll(".az-zb[data-panel]");
    var state = { grill: "", einbau: false };

    function save() {
      try { localStorage.setItem("azZubehoerFinder", JSON.stringify(state)); } catch (e) {}
      try {
        var u = new URL(window.location.href);
        if (state.grill) u.searchParams.set("grill", state.grill); else u.searchParams.delete("grill");
        if (state.einbau && state.grill !== "chiquito") u.searchParams.set("einbau", "1"); else u.searchParams.delete("einbau");
        history.replaceState(null, "", u.toString());
      } catch (e) {}
    }
    function render() {
      var isChiquito = state.grill === "chiquito";
      if (einbauBox) {
        einbauBox.disabled = isChiquito;
        einbauBox.checked = !isChiquito && state.einbau;
      }
      tiles.forEach(function (t) { t.setAttribute("aria-pressed", t.getAttribute("data-az-zbf-grill") === state.grill ? "true" : "false"); });
      var key = state.grill ? state.grill + (state.einbau && !isChiquito ? "-e" : "") : "";
      var shown = false;
      panels.forEach(function (p) {
        var on = p.getAttribute("data-panel") === key;
        p.hidden = !on;
        if (on) shown = true;
      });
      if (empty) empty.hidden = shown;
    }
    tiles.forEach(function (t) {
      t.addEventListener("click", function () {
        state.grill = t.getAttribute("data-az-zbf-grill");
        render(); save();
      });
    });
    if (einbauBox) einbauBox.addEventListener("change", function () { state.einbau = einbauBox.checked; render(); save(); });

    /* Startwerte: URL vor gespeicherter Auswahl */
    var valid = ["klein", "mittel", "gross", "chiquito"];
    var q = new URLSearchParams(window.location.search);
    var g = q.get("grill");
    if (g && valid.indexOf(g) > -1) {
      state.grill = g; state.einbau = q.get("einbau") === "1";
    } else {
      try {
        var s = JSON.parse(localStorage.getItem("azZubehoerFinder") || "null");
        if (s && valid.indexOf(s.grill) > -1) { state.grill = s.grill; state.einbau = !!s.einbau; }
      } catch (e) {}
    }
    render();
  }
  document.querySelectorAll("[data-az-zbf]").forEach(initFinder);
})();
